export const COLUMNS = [
  {
    label: 'Status',
    accessor: 'status',
    type: 'statusCheckbox',
    isFilterable: true,
    classNames: 'th-list-sticky th-list-cellwidth-120 pointer',
    selected: true,
    options: [
      {
        id: 'complete',
        value: 'complete',
        label: 'Complete',
        selected: false,
      },
      {
        id: 'incomplete',
        value: 'incomplete',
        label: 'Incomplete',
        selected: true,
      },
    ],
  },
  {
    label: 'Title',
    accessor: 'title',
    type: 'textWithEditDirect',
    isFilterable: false,
    classNames: 'th-list-cellwidth-240',
    selected: true,
  },
  {
    label: 'Customer',
    accessor: 'customer',
    type: 'customer',
    isFilterable: false,
    classNames: 'th-list-cellwidth-240',
    selected: true,
  },
  {
    label: 'Due date',
    accessor: 'dueDate',
    type: 'dueDate',
    isFilterable: false,
    isSortable: true,
    sortLabel: 'Due date: Earlier first',
    classNames: 'th-list-cellwidth-240',
  },
  {
    label: 'Owner',
    accessor: 'owner',
    type: 'owner',
    isFilterable: true,
    classNames: 'th-list-cellwidth-240',
    selected: false,
    options: [
      {
        id: 'blank',
        value: null, //for blank records
        label: 'Blank',
        selected: false,
      },
    ],
  },
  {
    label: 'Doctor',
    accessor: 'doctor',
    type: 'doctor',
    isFilterable: true,
    classNames: 'th-list-cellwidth-240',
    selected: true,
    options: [
      {
        id: 'blank',
        value: null, //for blank records
        label: 'Blank',
        selected: true,
      },
    ],
  },
  {
    label: 'Note',
    accessor: 'note',
    type: 'textWithEditDirect',
    isFilterable: false,
    classNames: 'th-list-cellwidth-240',
  },
  {
    label: 'Actions',
    accessor: 'tasks',
    type: 'deleteAction',
    isFilterable: false,
    classNames: 'th-list-cellwidth-actions',
  },
];
